<!--
패킹 컴포넌트 > 상품정보
------------------------------------
-->
<template>
    <div class="root">


        <table class="prod-info">
            <colgroup>
                <col style="width: 9rem">
                <col style="width: 12rem">
                <col style="width: 4rem">
                <col style="width: 10rem">
                <col style="width: 16rem">

                <col style="width: 6rem">
                <col>
            </colgroup>

            <thead>
            <tr>

                <th>
                    <i class="material-icons">done</i>
                    작업완료
                </th>
                <th>
                    보관장소/
                    상품번호
                </th>

                <th>
                    QTY
                </th>
                <th>
                    COLOR
                </th>
                <th>
                    SIZE
                </th>

                <th>
                    <i class="material-icons">image</i>
                </th>
                <th class="name">
                    상품정보
                </th>
            </tr>
            </thead>
            <tbody>
            <tr-prod
                v-for="(prod, index) in prods"
                :key="prod.id"
                :prod="prod"
                :csrf-token="csrfToken"
                :login-user-id="loginUserId"

                @done:error="$emit('done:error', null)"
            >
            </tr-prod>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        components: {
            'tr-prod': require('./tr-prod.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            // 상품정보
            prods: Array,
        },
        data: function () {
            return {
            };
        },
        computed: {

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .root {
        background-color: #fff;
    }
    .prod-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
            color: #aaa
        }

        th {
            font-size: 1rem;
            text-align: center;
            padding: 3px;
            font-weight: normal;
            color: #000;
            border: 1px solid #cfcfcf;
            background-color: #fafafa;

        }
    }
</style>